import { signOut } from "aws-amplify/auth";
import { useUserStore } from "../store/userStore";

const Dashboard = () => {
  const handleLogout = async () => {
    try {
      await signOut();
      useUserStore.getState().clearUserData();
      console.log("Usuário deslogado com sucesso");
      window.location.href = "/login";
    } catch (error) {
      console.error("Erro ao deslogar:", error);
    }
  };

  return (
    <div>
      <h1>Bem-vindo ao espaço admin!</h1>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default Dashboard;
